import { LeadEmbedForm } from 'components/Leads/LeadEmbedForm';
import Form from 'dataLayer/Form';
import { Lead } from 'dataLayer/Lead';
import { useLayout } from 'hooks/useLayout';
import { get } from 'lodash';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import React from 'react';
import { VistoCache } from 'utils/cache';

export const LeadsEmbedPage: NextPage<{
  leadEmbed: any;
  form: Form;
}> = ({ leadEmbed, form }) => {
  useLayout({
    layout: 'Embed',
  });

  const router = useRouter();
  const leadsEmbedId = get(router, 'query.leadEmbedId') as string;

  return (
    <LeadEmbedForm
      leadEmbedId={leadsEmbedId}
      leadEmbed={leadEmbed}
      form={form}
    />
  );
};

export const getServerSideProps = async (context: any) => {
  const { leadEmbedId } = context.query;

  if (!leadEmbedId) {
    return {
      notFound: true,
    };
  }

  const nextCache = VistoCache.getInstance();
  const cacheKey = nextCache.getKeyForLeadForm(leadEmbedId);
  const cachedData = await nextCache.get(cacheKey);

  if (cachedData && cachedData?.form) {
    return {
      props: {
        leadEmbed: cachedData?.leadEmbed ?? {},
        form: cachedData?.form ?? {},
      },
    };
  }

  const leadEmbed = await Lead.getEmbed({ embedId: leadEmbedId });

  if (!leadEmbed?.formName || !leadEmbed?.isActive) {
    return {
      notFound: true,
    };
  }

  const form = await Form.getLeadsFormRaw(leadEmbed.formName);

  if (!form?.id) {
    return {
      notFound: true,
    };
  }

  await nextCache.set(cacheKey, {
    leadEmbed,
    form,
  });

  // Serialize leadEmbed and form to avoid issues with non-serializable data
  const serializedLeadEmbed = JSON.parse(JSON.stringify(leadEmbed));
  const serializedForm = JSON.parse(JSON.stringify(form));

  return {
    props: {
      leadEmbed: serializedLeadEmbed,
      form: serializedForm,
    },
  };
};

export default LeadsEmbedPage;
